export default __webpack_public_path__ + "static/media/MemoryBooster.b1cc306c.jpeg";